/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForPeriodicSavingsPlans extends models.PeriodicBackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForPeriodicSavingsPlans");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForPeriodicSavingsPlans.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForPeriodicSavingsPlans>): BackgroundJobPayloadForPeriodicSavingsPlans {
        let obj = Object.assign(new BackgroundJobPayloadForPeriodicSavingsPlans(), model);
        BackgroundJobPayloadForPeriodicSavingsPlans.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForPeriodicSavingsPlans>): BackgroundJobPayloadForPeriodicSavingsPlans {
        if (!model) return null;
        return BackgroundJobPayloadForPeriodicSavingsPlans.newInstance(<BackgroundJobPayloadForPeriodicSavingsPlans> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForPeriodicSavingsPlans) {
        if (!obj) return;

        models.BackgroundJobPayloadForPeriodicSavingsPlans.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForPeriodicSavingsPlans): boolean {
        if (models.PeriodicBackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForPeriodicSavingsPlans.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
